import $ from "jquery";

function toElem(a0) {
	if(typeof a0 == 'string') {
		var a1 = document.getElementById(a0);
		if(!a1) {
			var a2 = document.getElementsByName(a0);
			if(a2.length > 0) a1 = a2[0];
		}
		a0 = a1;
	}
	return a0;
}

function SetNotify(a0, a1) {
	a0 = toElem(a0);
	if(a0.value != a1) {
		a0.value = a1;
		$(a0).trigger("change");
	}
	return false;
}

function TogglePickers(ctrl, id, n, data) {
	var o, a0 = ctrl.selectedIndex;
	var unk = ctrl.options.length > n + 1;

	SetNotify(id, "");
	o = toElem(id + "_text");
	if(o) o.value = "";
	o = toElem(id + "_filter");
	if(o) o.value = a0 >= 1 && a0 <= n ? data[a0 - 1] : "";

	for(var i = 1; i <= n; i++)
		if(i != a0)
			toElem(id + "_" + i).style.display = "none";
	if(unk && i != a0)
		toElem(id + "_" + i).style.display = "none";
	if(a0 !== 0) {
		var a1 = toElem(id + "_" + a0);
		a1.style.display = "";
		switch(a1.tagName) {
			case "SELECT":
				a1.selectedIndex = 0;
				break;
			case "NOBR":
				a1.firstChild.value = "";
				break;
		}
	}
}

function GetNewChoice(s, i) {
	// this, #selector
	s = s.selectedIndex === s.options.length - 1;
	i = $(i).toggle(s);
	if(s && i.length) { i.val(""); i[0].focus(); i[0].select(); }
}

function SetNewChoice(a1, a0) {
	// this, #selector
	a0 = $(a0);
	a1 = $(a1);
	var e = a0[0], i = 0, o = e.options, l = o.length, v = a1.val();
	if(v !== "") {
		var a2 = v.toLowerCase().trim();
		for(; i < l; i++) {
			if(o[i].value.toLowerCase() === a2)
				break;
		}
		if(i == l)
			e.insertBefore($("<option>", { value: v }).text(v)[0], o[--i]);
	}
	if(e.selectedIndex != i) {
		e.selectedIndex = i;
		a0.trigger("change");
	}
	a1.hide();
}

/* jshint -W098 */
if(typeof (window.QueryString) == "undefined")
	window.QueryString = $.qstring;

window.TogglePickers = TogglePickers;
window.GetNewChoice = GetNewChoice;
window.SetNewChoice = SetNewChoice;
